import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { EXPORT_API_REQUEST_URL, DASHBOARD_EXPORT_API_REQUEST_URL } from '../../../common/apiConfig';
import {
  REPORTS_EXPORT_ORDER_DETAIL_REPORT_BEGIN,
  REPORTS_EXPORT_ORDER_DETAIL_REPORT_SUCCESS,
  REPORTS_EXPORT_ORDER_DETAIL_REPORT_FAILURE,
  REPORTS_EXPORT_ORDER_DETAIL_REPORT_DISMISS_ERROR,
} from './constants';

export function exportOrderDetailReport(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_EXPORT_ORDER_DETAIL_REPORT_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      // const doRequest = axios.post(`${EXPORT_API_REQUEST_URL}/orderDetail/exportOrderDetail`, args);
      const doRequest = axios.post(`${DASHBOARD_EXPORT_API_REQUEST_URL}/orderDetail/exportOrderDetail`, args, {
        headers: {
            'Authorization': token,
          }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_EXPORT_ORDER_DETAIL_REPORT_SUCCESS,
            data: res.data.data,
          });
          resolve(res.data.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_EXPORT_ORDER_DETAIL_REPORT_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportOrderDetailReportError() {
  return {
    type: REPORTS_EXPORT_ORDER_DETAIL_REPORT_DISMISS_ERROR,
  };
}

export function useExportOrderDetailReport() {
  const dispatch = useDispatch();

  const { exportOrderDetailReportPending, exportOrderDetailReportError } = useSelector(
    state => ({
      exportOrderDetailReportPending: state.reports.exportOrderDetailReportPending,
      exportOrderDetailReportError: state.reports.exportOrderDetailReportError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(exportOrderDetailReport(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissExportOrderDetailReportError());
  }, [dispatch]);

  return {
    exportOrderDetailReport: boundAction,
    exportOrderDetailReportPending,
    exportOrderDetailReportError,
    dismissExportOrderDetailReportError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_EXPORT_ORDER_DETAIL_REPORT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        exportOrderDetailReportPending: true,
        exportOrderDetailReportError: null,
      };

    case REPORTS_EXPORT_ORDER_DETAIL_REPORT_SUCCESS:
      // The request is success
      return {
        ...state,
        exportOrderDetailReportPending: false,
        exportOrderDetailReportError: null,
      };

    case REPORTS_EXPORT_ORDER_DETAIL_REPORT_FAILURE:
      // The request is failed
      return {
        ...state,
        exportOrderDetailReportPending: false,
        exportOrderDetailReportError: action.data.error,
      };

    case REPORTS_EXPORT_ORDER_DETAIL_REPORT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        exportOrderDetailReportError: null,
      };

    default:
      return state;
  }
}
